import { useTranslation } from 'react-i18next';
import { ThemeIcon } from 'components/ThemeIcon/ThemeIcon';
import styles from './SlipSubmittedInfo.module.css';

interface Props {
  onReuse?: () => void;
  onClose?: () => void;
}

export const SlipSubmittedInfo = ({ onReuse, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div>Info</div>
      <div className={styles.message}>
        <div className={styles.messageRow}>
          <div className={styles.checkIconWrap}>
            <ThemeIcon icon="check-lg" alt="" variant="inline" />
          </div>
          <span>{t('slip_creation_success_message')}</span>
        </div>
      </div>
      <div className={styles.buttonWrapper}>
        <div onClick={onReuse}>
          Reuse bet slip
          <div className={styles.checkmark} />
        </div>
      </div>
      <div className={styles.buttonWrapper}>
        <div onClick={onClose}>
          Close
          <div className={styles.xmark} />
        </div>
      </div>
    </div>
  );
};
